const AUTH_STORAGE_KEY = 'access_token';

function getStorageBackend() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage;
}

export function getStoredAccessToken() {
  try {
    return getStorageBackend()?.getItem(AUTH_STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function setStoredAccessToken(token) {
  if (!token) {
    return;
  }

  try {
    getStorageBackend()?.setItem(AUTH_STORAGE_KEY, token);
  } catch {
    // Ignore storage write failures for now. Phase 2 keeps localStorage as the backing store.
  }
}

export function clearStoredAccessToken() {
  try {
    getStorageBackend()?.removeItem(AUTH_STORAGE_KEY);
  } catch {
    // Ignore storage cleanup failures.
  }
}

export function decodeJwtPayload(token) {
  try {
    const [, payload] = String(token || '').split('.');
    if (!payload) {
      return null;
    }

    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    return JSON.parse(window.atob(padded));
  } catch {
    return null;
  }
}

export function getTokenSnapshot() {
  const token = getStoredAccessToken();
  if (!token || token.length <= 10) {
    return {
      token: '',
      payload: null,
      status: 'missing',
      isAuthenticated: false,
    };
  }

  const payload = decodeJwtPayload(token);
  if (!payload) {
    return {
      token: '',
      payload: null,
      status: 'invalid',
      isAuthenticated: false,
    };
  }

  if (typeof payload.exp === 'number' && payload.exp <= Math.floor(Date.now() / 1000)) {
    return {
      token: '',
      payload,
      status: 'expired',
      isAuthenticated: false,
    };
  }

  return {
    token,
    payload,
    status: 'authenticated',
    isAuthenticated: true,
  };
}
